import React from "react";
import { Segment, Icon, Label } from "semantic-ui-react";
import "./SessionItem.scss";

export function SessionItem(props) {
  const { session, activeSession, setActiveSessionShow } = props;
  let iconName = "";
  switch (session.type) {
    case "CLASE":
      iconName = "bookmark outline";
      break;
    case "CUESTIONARIO":
      iconName = "question circle outline";
      break;
    case "EXAMEN":
      iconName = "tasks";
      break;
    default:
      iconName = "dont";
  }

  return (
    <div onClick={() => setActiveSessionShow(session)}>
      <Segment
        className={`session-item-show ${
          activeSession?.id === session.id ? "active" : ""
        }`}
      >
        <h4>
          <Icon name={iconName} /> {session.title}
        </h4>
        {activeSession?.id === session.id ? (
          <Label color="green">
            <Icon name="eye" />
          </Label>
        ) : null}
      </Segment>
    </div>
  );
}
